import { render, staticRenderFns } from "./Dish.vue?vue&type=template&id=9c1d5c7e&scoped=true&lang=pug"
import script from "./Dish.vue?vue&type=script&lang=js"
export * from "./Dish.vue?vue&type=script&lang=js"
import style0 from "./Dish.vue?vue&type=style&index=0&id=9c1d5c7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1d5c7e",
  null
  
)

export default component.exports